import React from 'react';
import styled from 'styled-components';
import { grayDarkM } from 'web-ui-kit/colors';

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var _templateObject, _templateObject2;

function HelpIcon(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? grayDarkM : _ref$color,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? undefined : _ref$style;
  return (
    /*#__PURE__*/
    React.createElement(Container, {
      onClick: onClick,
      style: style
    },
    /*#__PURE__*/
    React.createElement(StyledSVG, {
      "aria-label": "help icon",
      role: "img",
      className: className,
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /*#__PURE__*/
    React.createElement("path", {
      d: "M11.0134 14.1333H12.5068V13.7067C12.5468 12.96 13.1868 12.4133 13.8134 11.8133C14.4134 11.2267 14.9868 10.6133 14.9868 9.66667C14.9868 8.37333 14.0934 7.33333 12.1868 7.33333C10.4001 7.33333 9.16011 8.42667 9.06677 10.1733H10.6134C10.7068 9.25333 11.2801 8.66667 12.1068 8.66667C12.9201 8.66667 13.2934 9.10667 13.2934 9.78667C13.2934 10.3333 12.8534 10.8 12.3601 11.2933C11.7201 11.92 11.0134 12.5733 11.0134 13.6267V14.1333ZM11.7468 17.0933C12.3334 17.0933 12.8134 16.64 12.8134 16.0667C12.8134 15.48 12.3334 15.0267 11.7468 15.0267C11.1468 15.0267 10.6534 15.48 10.6534 16.0667C10.6534 16.64 11.1468 17.0933 11.7468 17.0933Z",
      fill: color
    }),
    /*#__PURE__*/
    React.createElement("circle", {
      cx: "12",
      cy: "12",
      r: "11.5",
      stroke: color
    })))
  );
}

var Container = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n"])));
var StyledSVG = styled.svg(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  cursor: pointer;\n"])));
export default HelpIcon;